import gql from 'graphql-tag';

const MAKE_SERVICE_DOCKETS_NEXT_STOPS = gql`
	mutation makeServiceDocketsNextStopsMutation(
		$serviceRunId: ID!,
		$serviceDocketIds: [ID!]!,
		$reason: String!,
		$exactOrder: Boolean,
		$adminTraining: Boolean,
	) {
		makeServiceDocketsNextStops(
			serviceRunId: $serviceRunId,
			serviceDocketIds: $serviceDocketIds,
			reason: $reason,
			exactOrder: $exactOrder,
			adminTraining: $adminTraining,
		) {
			id
			machineOrder
			myDayOrderChanges {
				at
				reason
			}
		}
	}
`;

export default MAKE_SERVICE_DOCKETS_NEXT_STOPS;
